import Typography from '@klv/atoms/typography';
import styled from 'styled-components';

export const TotalDescription = styled.div`
  padding-top: 1.6rem;
`;

export const YAxisHeadline = styled(Typography)`
`;

export const ValueTitle = styled(Typography)``;

export const ValueSubhead = styled(Typography)``;

export const TotalTile = styled(Typography)``;

export const ContentSubhead = styled(Typography)``;

export const ContentTitle = styled(Typography)``;
